import React from 'react'
import PropTypes from 'prop-types'

import S from './Loading.styled'
import LoadingTitle from './items/Title'
import LoadingSubtitle from './items/Subtitle'
import LoadingText from './items/Text'
import LoadingButton from './items/Button'
import LoadingButtonGroup from './items/ButtonGroup'

const Loading = ({
  children,
  className,
  isAlternateColor = false,
  isAnimated = false,
}) => {
  return (
    <S.Loading
      className={className}
      isAlternateColor={isAlternateColor}
      isAnimated={isAnimated}
    >
      {children}
    </S.Loading>
  )
}

Loading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isAlternateColor: PropTypes.bool,
  isAnimated: PropTypes.bool,
}

const Title = (props) => <LoadingTitle {...props} />
Loading.Title = Title

const Subtitle = (props) => <LoadingSubtitle {...props} />
Loading.Subtitle = Subtitle

const Text = (props) => <LoadingText {...props} />
Loading.Text = Text

const Button = (props) => <LoadingButton {...props} />
Loading.Button = Button

const ButtonGroup = (props) => <LoadingButtonGroup {...props} />
Loading.ButtonGroup = ButtonGroup

export default Loading
